export const getSurfaceType = (surfaceType) => {
  if (surfaceType) {
    let response = '';
    const surfaceTypeFiltered = surfaceType.split('-')[0];
    switch (surfaceTypeFiltered) {
      case 'CONC':
      case 'CONCRETE':
        response = 'CONCRETE';
        break;
      case 'ASPH':
      case 'ASPHALT':
        response = 'ASPHALT';
        break;
      case 'SNOW':
        response = 'SNOW';
        break;
      case 'ICE':
        response = 'ICE';
        break;
      case 'MATS':
        response = 'MATS';
        break;
      case 'TREATED':
        response = 'TREATED';
        break;
      case 'GRAVEL':
        response = 'GRAVEL';
        break;
      case 'TURF':
        response = 'TURF';
        break;
      case 'DIRT':
        response = 'DIRT';
        break;
      case 'WATER':
        response = 'WATER';
        break;
      default:
        response = 'REVIEW DICTIONARY';
        break;
    }
    return response;
  }
  return 'UNKNOWN';
};

export const getIntensity = (option) => {
  if (option) {
    let response = '';
    switch (option) {
      case 'HIGH':
        response = 'HIGH';
        break;
      case 'MED':
      case 'MEDIUM':
        response = 'MEDIUM';
        break;
      case 'LOW':
        response = 'LOW';
        break;
      case 'NSTD':
      case 'NONSTD':
        response = 'NONSTD';
        break;
      case 'NONE':
        response = 'NONE';
        break;
      default:
        response = 'REVIEW DICTIONARY';
        break;
    }
    return response;
  }
  return '';
};

export const getApproachLightSystem = (option) => {
  if (option) {
    let response = '';
    switch (option) {
      case 'ALSF1':
        response = 'ALSF-I';
        break;
      case 'ALSF':
        response = 'ALSF-I';
        break;
      case 'ALSF2':
        response = 'ALSF-II';
        break;
      case 'MALS':
        response = 'MALS/MALSF';
        break;
      case 'MALSF':
        response = 'MALS/MALSF';
        break;
      case 'MALSR':
        response = 'MALSR/SSALR';
        break;
      case 'SSALS':
        response = 'SSALF/SSALS';
        break;
      case 'SSALF':
        response = 'SSALF/SSALS';
        break;
      case 'SSALR':
        response = 'MALSR/SSALR';
        break;
      case 'LDIN':
        response = 'LDIN/RLLS';
        break;
      case 'RLLS':
        response = 'LDIN/RLLS';
        break;
      case 'NEON':
        response = 'NONE';
        break;
      case 'MIL OVRN':
        response = 'NONE';
        break;
      case 'NSTD':
        response = 'NONE';
        break;
      default:
        response = option;
        break;
    }
    return response;
  }
  return '';
};
